// const contractAddress = "0x5568B61A6030E1EE1A7EC560588e516A4F60B2c8"// normal auction old
const contractAddress = "0x61C3b7d9a051A906AdF8e88aB16ded96EEB72a50"// normal auction

export default contractAddress